import { Heading, Subheading } from "../design/heading";

interface LoadingViewProps {
  title?: string;
  message?: string;
}

const LoadingView: React.FC<LoadingViewProps> = ({ title, message }) => {
  return (
    <div>
      <div className="flex items-center justify-center">
        <div className="flex flex-col items-center justify-center">
          <div className="w-12 h-12 border-t-4 border-b-4 rounded-full animate-spin" />
          {title && <Heading className="mt-4">{title}</Heading>}
          {message && <Subheading className="mt-2">{message}</Subheading>}
        </div>
      </div>
    </div>
  );
};

export default LoadingView;
